import AnalyticsProvider from "@COMPONENTS/provider/AnalyticsProvider";
import PartnerResizeProvider from "@COMPONENTS/provider/PartnerResizeProvider";
import ScrollRestoreProvider from "@COMPONENTS/provider/ScrollRestoreProvider";
import OverlayProvider from "@COMPONENTS/provider/OverlayProvider";
// import AuthProvider from "@COMPONENTS/provider/AccountProvider";

const AppProvider = ({children}) => (
	<>
		{/* 태깅 */}
		<AnalyticsProvider>
			{/* 제휴 리사이징 */}
			<PartnerResizeProvider>
				{/* 스크롤 복원  */}
				<ScrollRestoreProvider>
					{/* 레이어 팝업 */}
					<OverlayProvider>{children}</OverlayProvider>
				</ScrollRestoreProvider>
			</PartnerResizeProvider>
		</AnalyticsProvider>
	</>
);

export default AppProvider;
